export default __webpack_public_path__ + "static/media/eua-flag.d091fc0c.svg";